import React, { Component } from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

class ErrorHolder extends Component {
  render() {
    if (this.props.error) {
      return (
        <div>
          <Modal
            isOpen={!!this.props.error}
            toggle={this.props.toggleError}
            sz="lg"
          >
            <ModalHeader>ERROR:</ModalHeader>
            <ModalBody>{this.props.error}</ModalBody>
            <ModalFooter>
              <Button color="danger" onClick={this.props.toggleError}>
                Dismiss
              </Button>
            </ModalFooter>
          </Modal>
        </div>
      );
    }

    return <div />;
  }
}

export default ErrorHolder;



// WEBPACK FOOTER //
// ./src/components/ErrorHolder.js